<template>
    <div class="content-view">
        <h2 class="fs-24 text-center fc-theme">淘宝排名查询</h2>
        <p class="subtitle text-center fs-14 fc-666">根据指定关键词，无账号登录状态下，商品的排名，建议选择前50页，超过50页查询速度减慢,可以批量查询</p>
        <top-price code="itemrank"></top-price>
        <el-form class="marginT-20" label-width="100px" label-position="left">
            <el-form-item label="终端：">
                <el-radio-group @change="changeMedia" v-model="form.media">
                    <el-radio :label="0">天猫APP</el-radio>
                    <el-radio :label="1">手淘APP</el-radio>
                    <el-radio label="invalid">京东PC端</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="筛选条件：">
                <el-radio-group @change="changeType" v-model="form.type">
                    <el-radio label="all">全部商品</el-radio>
                    <el-radio v-if="form.media == 1" label="tmall">天猫</el-radio>
                </el-radio-group>
                <el-checkbox-group v-if="form.media == 0" v-model="form.tag_id">
                    <el-checkbox :label="13">包邮</el-checkbox>
                    <el-checkbox :label="14">天猫</el-checkbox>
                    <el-checkbox :label="16">消费者保障</el-checkbox>
                    <el-checkbox :label="15">全球购</el-checkbox>
                    <el-checkbox :label="18">淘金币抵扣</el-checkbox>
                    <el-checkbox :label="20">七+天内退货</el-checkbox>
                </el-checkbox-group>
                <el-checkbox-group v-if="form.media == 1 && form.type == 'all'" v-model="form.tag_id">
                    <el-checkbox :label="0">包邮</el-checkbox>
                    <el-checkbox :label="1">赠送退货运费险</el-checkbox>
                    <el-checkbox :label="2">货到付款</el-checkbox>
                    <el-checkbox :label="2">新品</el-checkbox>
                    <el-checkbox :label="4">二手</el-checkbox>
                    <el-checkbox :label="5">天猫</el-checkbox>
                    <el-checkbox :label="6">正品保障</el-checkbox>
                    <el-checkbox :label="8">7+天内退货</el-checkbox>
                    <el-checkbox :label="3">海外商品</el-checkbox>
                </el-checkbox-group>
                <el-checkbox-group v-if="form.media == 1 && form.type == 'tmall'" v-model="form.tag_id">
                    <el-checkbox :label="0">包邮</el-checkbox>
                    <el-checkbox :label="1">赠送退货运费险</el-checkbox>
                    <el-checkbox :label="2">货到付款</el-checkbox>
                    <el-checkbox :label="2">新品</el-checkbox>
                    <el-checkbox :label="6">正品保障</el-checkbox>
                    <el-checkbox :label="3">海外商品</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="排序：">
                <el-radio-group v-model="form.sort">
                    <el-radio :label="0">默认</el-radio>
                    <el-radio v-if="form.media == 0" :label="1">人气</el-radio>
                    <el-radio :label="2">销量</el-radio>
                    <el-radio v-if="form.media == 0" :label="3">信用</el-radio>
                    <el-radio v-if="form.media == 0" :label="4">最新</el-radio>
                    <el-radio :label="5">价格升</el-radio>
                    <el-radio :label="6">价格降</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="查询页码：">
                <el-col :span="4">
                    <el-input v-model.number="form.start_page" placeholder="请输入起始页数"></el-input>
                </el-col>
                <el-col class="text-center" :span="2">到</el-col>
                <el-col :span="4">
                    <el-input v-model.number="endPage"
                        @blur="endPage ? form.start_page > endPage ? endPage = form.start_page : '' : ''"
                        placeholder="请输入结束页数"></el-input>
                </el-col>
                <!--
                <el-col :span="2">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        content="非会员可以查询1到10页，会员商家可以查询1到100页"
                        placement="top"
                    >
                        <i class="marginL-20 el-icon-question"></i>
                    </el-tooltip>
                </el-col> -->
            </el-form-item>
            <el-form-item label="商品链接：">
                <el-input v-model.number="form.item_id" placeholder="请输入商品链接"></el-input>
            </el-form-item>
            <el-form-item label="关键字：">
                <el-input type="textarea" :rows="8" v-model="text" placeholder="请输入你要查询的关键字，一行一个"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button :type="dialog.show ? 'info' : 'danger'" :disabled="dialog.show" @click="onSubmit">{{
                    dialog.show ? '查询中...' : '提交查询' }}</el-button>
            </el-form-item>
        </el-form>
        <div class="search-content" v-if="dialog.show">
            <div>
                <p>共<span class="fc-theme"> {{ dialog.allKey }} </span>个关键字，目前正在查询第<span class="fc-theme">
                        {{ dialog.nowKey }} </span>个关键字</p>
                <br>
                <el-progress :percentage="dialog.process"></el-progress>
                <p class="marginT-10">正在查询第<span class="fc-theme"> {{ form.start_page + dialog.page }}</span> 页</p>
            </div>
            <span class="marginT-10">
                <el-button class="marginT-10" @click="dialogClose">取 消</el-button>
            </span>
        </div>

        <div v-if="resultList.length > 0" class="query-record marginT-50">
            <el-card class="box-card flex-1 marginT-20">
                <div slot="header" class="flex flex-between">
                    <span class="fw-bold fc-333">查询结果</span>
                </div>
                <div>
                    <div class="table">
                        <el-table :data="resultList" fit style="border: 1px solid #eee;">
                            <el-table-column prop="keyword" label="关键字"></el-table-column>
                            <el-table-column prop="title" label="标题信息"></el-table-column>
                            <el-table-column label="店铺信息">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.nodata">{{ scope.row.msg ? scope.row.msg :
                    '未查到排名，请扩大查询范围' }}</span>
                                    <span v-else>店铺名：{{ scope.row.nick }},店铺类型：{{ scope.row.seller_type == 1 ? '天猫' :
                    'c' }}店，店铺等级：{{ scope.row.seller_level }},商品销量：{{ scope.row.view_sales }},
                                        直通车：{{ scope.row.isp4p == 0 ? '未' : '已' }}开通</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="排名">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.nodata">{{ scope.row.msg ? scope.row.msg :
                    '未查到排名，请扩大查询范围' }}</span>
                                    <span v-else>第{{scope.row.page}}页，第{{scope.row.pos}}个</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-card>
        </div>

        <el-card class="box-card tip-card">
            <div slot="header" class="clearfix">
                <el-tabs>
                    <el-tab-pane label="淘宝排名查询"></el-tab-pane>
                </el-tabs>
            </div>
            <div>
                <div class="title marginT-10 fc-theme fs-18">功能介绍</div>
                <div class="content fs-14 fc-666">
                    1、输入指定的关键词，选择终端、筛选条件、排序、查询页码后，填写商品链接，提交查询，可查出在未登入账号状态下，宝贝在该关键词下对应的排名。<br>
                    2、商品推广时，需要实时检测商品排名的动态变化，手动去翻查会比较耗费人工成本、时间成本。此功能正是为了解决这一问题，只要输入想查询的信息，即可得到商品在该关键字下的排名。<br>
                    3、如果商品的排名相对靠前，可以直接让买手搜索下单。如果商品排名相对靠后，可使用搜索权重推送功能，提高宝贝在买手搜索结果页的排名，帮助买手快速找到商品。
                </div>
                <div class="title marginT-10 fc-theme fs-18">注意</div>
                <div class="content fs-14 fc-666">
                    1、建议页数选择前50页，超过50页时，查询速度会相对减慢。<br>
                    2、如果想要查询的页数超过50页，建议批量查询，提高查询效率。<br>
                    3、接口合作请加微信{{getkfWx()}} 
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import appConfig from '../mixin/appConfig';
import { mapState } from 'vuex';
export default {
    data() {
        return {
            dialog: {
                show: false,
                process: 1,
                allKey: 1, // 所有关键字数量
                nowKey: 1, // 当前第几个关键字
                page: 0, // 查询到第多少页
                complete: false // 提前结束
            },
            isHasMoney: true,
            pricePreMonth: {},
            terminal: 1,
            text: '',
            endPage: 10,
            form: {
                pattern: 1, // 0 模糊 1 精准
                media: 1,
                type: 'all',
                tag_id: [],
                sort: 0,
                start_page: 1,
                item_id: ''
            },
            resultList: []
        }
    },
    mixins: [appConfig],
    computed: mapState(['userData', 'phone']),
    methods: {
        async checkOrder(obj) {
            // const maxPage = this.userData.is_vip ? 100 : 30 // 最多查询页数
            // const maxCount = this.userData.is_vip ? 5 : 10 // 最多查询次数
            // let maxCount = Math.floor((this.endPage - this.form.start_page) / 2) + 1
            let maxCount = 1;

            let that = this

            let pci = setInterval(function () {
                if (that.dialog.process < 99) {
                    that.dialog.process += Math.floor(Math.random() * 5) + 1
                }
            }, 1000)

            let reObj = {}
            let msg = ''
            for (let i = 0; i < maxCount; i++) {
                const data = await this.$fetch('/api/proxy/web/itemrank', { ...obj, start_page: obj.start_page, end_page: this.endPage }, 'post')

                if (data.msg.indexOf('点券数不足') > -1 || data.msg.indexOf("使用次数已达上限") > -1) {
                    this.isHasMoney = false
                    this.dialog.complete = true
                    this.dialog.show = false
                    break
                }

                if (data.msg.indexOf('商品链接异常') > -1) {
                    msg = '商品链接异常，请检查链接是否正常'
                    break
                }

                if (data.code !=0) {
                    if (data.msg && data.msg.indexOf('需要开通VIP') > -1) {
                        this.$confirm('您好,该功能仅支持VIP用户使用，请您去升级vip用户！', '提示', {
                            confirmButtonText: '去升级VIP',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.$router.push({path: "/vip"})
                        }).catch(() => {
                    
                        });
                    } else {
                        this.$message.error(data.msg ? data.msg : '请求失败')
                    }

                    this.dialog.complete = true
                    break
                }

                if (this.dialog.complete) {
                    break
                }

                if (data.code == 0 && data.data.items && data.data.items.length > 0) {
                    reObj = { keyword: obj.keyword, ...data.data.items[0] }
                    break
                } else {
                    // this.dialog.page += 2
                    // this.dialog.process = parseInt(((i + 1) / maxCount * 100).toFixed(0))
                }
            }

            if (!this.dialog.complete) {
                if (reObj.keyword) {
                    this.resultList.push(reObj)
                } else {
                    this.resultList.push({ keyword: obj.keyword, nodata: 1, msg })
                }
            }
        },
        async priceLimit() {
            const data = await this.$fetch('/tool/apps/api-info', { name: 'itemrank' })
            this.pricePreMonth = data.data
        },
        changeMedia(val) {
            if (val == 'invalid') {
                this.form.media = 0
                this.$alert('该功能调整中，近期即将开放', '提示', {
                    confirmButtonText: '确定'
                });
            }
            if (val == '0') {
                this.form.type = 'all'
            }
            this.form.tag_id = []
            this.form.sort = 0
        },
        changeType(val) {
            this.form.tag_id = []
        },
        handleClose(done) {
            this.$confirm('此操作将停止继续查询, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.dialog.complete = true
                done()
            }).catch(() => {

            });
        },
        dialogClose() {
            this.$confirm('此操作将停止继续查询, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.dialog.complete = true
                this.dialog.show = false
            }).catch(() => {

            });
        },
        // handleChangeTer(val) {
        //     if (val == 'invalid') {
        //         this.terminal = 1
        //         this.$alert('该功能调整中，近期即将开放', '提示', {
        //             confirmButtonText: '确定'
        //             });
        //     }
        // },
        async onSubmit() {
            if (!localStorage.token) {
                this.$bus.emit('openLogin')
                return
            }

            window.checkDiscountPackage("itemrank")

            if (!this.text) {
                this.$message.error('请填写关键字')
                return
            }
            if (!this.form.item_id) {
                this.$message.error('请填写商品链接')
                return
            }
            if (
                this.endPage &&
                (this.form.start_page > this.endPage ||
                    !this.form.start_page)
            ) {
                this.$message.error('请正确填写页码')
                return
            }
            if (!this.form.start_page || this.form.start_page < 1 || !this.endPage) {
                this.$message.error('请正确填写页码')
                return
            }
            if (this.endPage) {
                if (this.userData.is_vip) {
                    if (this.endPage - this.form.start_page >= 100) {
                        this.$message.error('会员可以免费查前100页，非会员仅限前10页')
                        return
                    }
                } else {
                    if (this.endPage - this.form.start_page >= 10) {
                        this.$message.error('会员可以免费查前100页，非会员仅限前10页')
                        return
                    }
                }
            }
            let list = this.text.split('\n')
            list = list.filter(x => x && x.replace(/ /g, ''))
            if (list.length == 0) {
                this.$message.error('请填写关键字')
                return
            }
            if (list.length > 1 && !this.userData.is_vip) {
                this.$message.error('非会员仅限单个关键字查询')
                return
            }
            this.resultList = []

            this.dialog.allKey = list.length
            this.dialog.show = true

            for (const key in list) {
                this.dialog.nowKey = Number(key) + 1
                this.dialog.process = 0
                this.dialog.page = 0
                if (this.dialog.complete) {
                    break
                }
                await this.checkOrder({ keyword: list[key], ...this.form, tag_id: this.form.tag_id.join(',') })
            }

            if (!this.dialog.complete) {
                this.$alert('查询结束，请检查查询结果', '提示', {
                    confirmButtonText: '确定'
                })
            }

            this.dialog.complete = false
            this.dialog.show = false
        }
    },
    mounted() {
        if (this.$store.state.phone) {
            this.priceLimit()
        }
    },
    watch: {
        phone(newValue) {
            if (newValue) {
                this.priceLimit()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.search-content {
    padding: 16px 60px;
}
</style>
